import { render, staticRenderFns } from "./ViewInteractiveTemplate.vue?vue&type=template&id=4dd544a4&scoped=true"
import script from "./ViewInteractiveTemplate.vue?vue&type=script&lang=js"
export * from "./ViewInteractiveTemplate.vue?vue&type=script&lang=js"
import style0 from "./ViewInteractiveTemplate.vue?vue&type=style&index=0&id=4dd544a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd544a4",
  null
  
)

export default component.exports